<p class="mk-muted" *ngIf="store.loadingSalesItems">Loading the items&hellip;</p>

<ng-container *ngIf="!store.loadingSalesItems">
  <div class="fx-search">
    <i class="bi bi-search" aria-hidden="true"></i>
    <input
      type="search"
      [id]="idPrefix + 'sales-items-search'"
      [value]="query"
      placeholder="Search by name or code"
      aria-label="Search these items"
      autocomplete="off"
      (input)="search($any($event.target).value)"
    />
  </div>

  <p class="mk-muted" *ngIf="!filtered.length">No items match "{{ query.trim() }}".</p>

  <ng-container *ngIf="filtered.length">
    <ul class="fx-rows">
      <li class="fx-row" *ngFor="let row of shown; trackBy: trackRow">
        <div class="fx-row-name">
          <b>{{ row.name }}</b>
          <span class="mk-muted">{{ row.code }}<ng-container *ngIf="row.itemIds.length > 1"> &middot; {{ row.itemIds.length }} items share this code</ng-container></span>
          <span class="fx-status ok" *ngIf="(row.groupId !== null || row.usesDefault) && !row.saving"><i class="bi bi-check-lg" aria-hidden="true"></i> Saved</span>
          <span class="fx-row-error" role="alert" *ngIf="row.error">{{ row.error }}</span>
        </div>
        <select
          class="fx-row-select"
          [id]="idPrefix + 'sales-item-' + row.recordId"
          [attr.aria-label]="'Sales group for ' + row.name"
          [disabled]="row.saving"
          (change)="choose(row, $any($event.target).value)"
        >
          <option value="" disabled [selected]="row.groupId === null && !row.usesDefault">Choose a sales group&hellip;</option>
          <option value="default" *ngIf="store.usableDefault as d" [selected]="row.usesDefault">Default ({{ d.description }})</option>
          <option *ngFor="let g of store.usableSalesGroups" [value]="g.id" [selected]="g.id === row.groupId">{{ g.description }}</option>
        </select>
      </li>
    </ul>
    <div class="fx-more">
      <span class="mk-muted">Showing {{ shown.length }} of {{ filtered.length }}.</span>
      <button type="button" class="link-btn" *ngIf="more > 0" (click)="limit = limit + more">Show {{ more }} more</button>
    </div>
  </ng-container>
</ng-container>
